import { useCallback, useState } from 'react';
import { LockKeyhole } from 'lucide-react';

const EXPECTED =
  (import.meta.env.VITE_CASH_LEDGER_GATE_PASSWORD as string | undefined)?.trim() || 'accounting';

export const CASH_LEDGER_UNLOCK_KEY = 'cash_ledger_unlocked';

export function CashLedgerGate({ onUnlock }: { onUnlock: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback((event: React.FormEvent) => {
    event.preventDefault();
    if (!password.trim()) return;
    if (password.trim() === EXPECTED) {
      sessionStorage.setItem(CASH_LEDGER_UNLOCK_KEY, 'true');
      onUnlock();
      return;
    }
    setError('Incorrect password');
    setPassword('');
  }, [onUnlock, password]);

  return (
    <div className="flex h-full items-center justify-center overflow-hidden p-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <LockKeyhole className="text-violet-400 mx-auto mb-3" size={28} />
          <h1 className="text-foreground text-xl font-bold">Cash Ledger preview</h1>
          <p className="text-muted-foreground mt-1 text-sm">Enter the shared accounting password.</p>
        </div>
        <div className="bg-card border-border rounded-lg border p-6">
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
                setError(null);
              }}
              placeholder="Password"
              aria-label="Cash Ledger password"
              autoFocus
              className="bg-background border-border text-foreground focus:border-primary w-full rounded border px-3 py-2 text-sm focus:outline-none"
            />
            <button
              type="submit"
              disabled={!password.trim()}
              className="bg-primary text-primary-foreground hover:bg-primary/90 mt-3 w-full rounded px-3 py-2 text-sm font-medium disabled:opacity-50"
            >
              Enter
            </button>
          </form>
        </div>
        {error && (
          <div className="bg-destructive/10 border-destructive/20 mt-3 rounded border p-2">
            <p className="text-destructive text-center text-xs">{error}</p>
          </div>
        )}
        <p className="text-muted-foreground mt-3 text-center text-[10px]">
          This is a UI deterrent. Relay role and organization checks remain the access boundary.
        </p>
      </div>
    </div>
  );
}
